import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { constants } from '../constants';
import { getCurrentCompanyInfo } from './helpers/HelperFunctions';
import { Svg } from './Svg';
export const showModalDialog = showModal;
export const hideModalDialog = hideModal;
class ModalDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			currentCompanyName: ''
		};
		this.closeDialog = this.closeDialog.bind(this);
	}
	componentDidMount() {
		let { header, dialogId, additionalClasses } = this.props;
		if (!header && constants.placeholderDialogId !== dialogId && !additionalClasses?.split(" ").includes("transparente")) {
			const currentObject = this;
			getCurrentCompanyInfo().then((info) => {
				currentObject.setState({ currentCompanyName: info?.name });
			})
		}
	}
	closeDialog() {
		const { dialogId, canClose, closeCalback } = this.props;
		if (canClose) {
			hideModal(dialogId);
			if (closeCalback)
				closeCalback();
		}
	}
	render() {
		const { dialogId, children, header, icone, additionalClasses, buttons, canClose, headerIconButtons } = this.props;
		const { currentCompanyName } = this.state;
		const closeDialogFunction = this.closeDialog;
		let dialogFormId = "form_" + dialogId;
		let index = 0;
		return (
			<div className={"modal fade show " + (additionalClasses ? additionalClasses : "") + (canClose ? " can-close" : "") + (header ? " with-title" : "")} id={dialogFormId} onMouseDown={(e) => {
				e = e || window.event;
				var target = e.target || e.srcElement;
				var mouseUpEvent = function (e) {
					e = e || window.event;
					var upTarget = e.target || e.srcElement;
					if (upTarget.id === dialogFormId) {
						closeDialogFunction();
						target.removeEventListener("mouseup", mouseUpEvent);
					}
					else {
						target.removeEventListener("mouseup", mouseUpEvent);
					}
				}
				if (target.id === dialogFormId) {
					target.addEventListener("mouseup", mouseUpEvent);
				}
			}}>
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className={"modal-header" + (icone || header ? " with-icon" : "") + (headerIconButtons && headerIconButtons.length > 0 ? " with-header-btns" : "")}>
							{icone && <img className="modal-icone" src={icone} alt="" />}
							{
								!header &&
								<div className="form-header-subtitle-right form-subtitle">{currentCompanyName}</div>
							}
							{header && <div className="modal-header-title">{header}</div>}
							{headerIconButtons && 
								<div className="header-btns">
								    {headerIconButtons.map(btn =>
									    <div className="header-icon-btn" onClick={btn.onClickCallback}>
										    <Svg src={btn.src} />
									    </div>
                                    )}
                                </div>
                            }
							{canClose && <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeDialogFunction}>
								<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill="black" />
								</svg>
							</button>}
						</div>
						<div className="modal-body">
							{children}
						</div>
						{buttons && buttons.length > 0 &&
							<div className="modal-footer">
							{buttons.map(btn =>
								<button type="button" className={"btn " + btn.class} key={"btn_" + index++} onClick={btn.clickHandler && btn.clickHandler}>{btn.title}</button>
								)}
							</div>
						}
					</div>
				</div>
			</div>
		);
	}
}
function showModal(dialogId, header, icone, children, additionalClasses, canClose = true, buttons = [], closeCalback = null, headerIconButtons = []) {
	if (constants.placeholderDialogId !== dialogId)
		hideModal(constants.placeholderDialogId);
	var dialog = document.getElementById(dialogId);
	if (dialog) {
		ReactDOM.render(
			<ModalDialog header={header} icone={icone} dialogId={dialogId} additionalClasses={additionalClasses} canClose={canClose} buttons={buttons} closeCalback={closeCalback} headerIconButtons={headerIconButtons} >
				{children}
			</ModalDialog>,
			dialog);
		if (document.body.style.position !== "fixed") {
			document.body.style.top = "-" + getBodyScrollTop() + "px";
			document.body.style.overflowY = "scroll";
			document.body.style.width = "100%";
			document.body.style.position = "fixed";
		}
	}
}
function hideModal(dialogId) {
	var dialog = document.getElementById(dialogId);
	ReactDOM.render(
		"",
		dialog);
	if (!isAnotherDialogShown(dialogId)) {
		var scrollValue = document.body.style.top;
		if (scrollValue.startsWith('-'))
			scrollValue = scrollValue.substring(1, scrollValue.length);
		if (scrollValue.endsWith('px'))
			scrollValue = scrollValue.substring(0, scrollValue.length - 2);
		let style = document.body.style;
		style.overflowY = style.width = style.position = style.top = "";
		if (scrollValue)
			window.scrollTo(0, parseInt(scrollValue));
	}
}
export function hideAllDialogs() {
	let dialogs = document.querySelectorAll(".modal-dialog-contaner");
	for (let i = 0; i < dialogs.length; i++) {
		ReactDOM.render(
			"",
			dialogs[i]);
	}
	var scrollValue = document.body.style.top;
	if (scrollValue.startsWith('-'))
		scrollValue = scrollValue.substring(1, scrollValue.length);
	if (scrollValue.endsWith('px'))
		scrollValue = scrollValue.substring(0, scrollValue.length - 2);
	let style = document.body.style;
	style.overflowY = style.width = style.position = style.top = "";
	if (scrollValue)
		window.scrollTo(0, parseInt(scrollValue));
}
function isAnotherDialogShown(dialogId) {
	let dialogs = document.querySelectorAll(".modal-dialog-contaner");
	for (let i = 0; i < dialogs.length; i++) {
		if (dialogs[i].id !== dialogId && dialogs[i].children?.length > 0) {
			return true;
		}
	}
	return false;
}
function getBodyScrollTop() {
	return window.scrollY ? window.scrollY : (document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop);
}